import script from "./DocumentPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&setup=true&lang=js"

import "./DocumentPreview.vue?vue&type=style&index=0&id=fe8dfabe&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe8dfabe"]])

export default __exports__